/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { ReactComponent as ClockIcon } from '../../../../../assets/icons/clock-icon.svg'
import { addNewWithdraw, updateWithdraw } from '../../../../../Redux/withdraws/withdrawsSlice'
import { useTranslation } from 'react-i18next'
import { getTiraneDateString } from '../../../../../utils/dateFormatter'

const index = ({ close, data }) => {
  const { t } = useTranslation() || ((text) => text)
  const { editing, exp } = data || {}
  const initDate = getTiraneDateString()
  const dispatch = useDispatch()
  const [isWithdraw, setIsWithdraw] = useState(true)

  // Add date formatting function
  const formatDateToEuropean = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Add date parsing function
  const parseEuropeanDate = (dateString) => {
    if (!dateString) return '';
    const [day, month, year] = dateString.split('/');
    if (!day || !month || !year) return '';
    return `${year}-${month}-${day}`;
  };

  const submitData = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const formObject = {
      date: formData.get('date'),
      description: formData.get('description') || '',
      amount: Number(formData.get('amount')) || 0,
      type: isWithdraw ? 'withdraw' : 'input',
      close
    }
    
    // Debug logging for manual money addition
    console.log('💰 Manual money addition/withdrawal:', {
      type: formObject.type,
      amount: formObject.amount,
      description: formObject.description,
      date: formObject.date,
      isWithdraw: isWithdraw
    })
    
    if (!editing) {
      dispatch(addNewWithdraw(formObject))
    } else if (editing && exp) {
      dispatch(
        updateWithdraw({
          ...formObject,
          id: exp.id
        })
      )
    }
  }
  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.form_header}>
        <h2 className={styles.header_text}>{t('ADD_NEW_WITHDRAW')}</h2>
        <button className={styles.close_btn} onClick={close}>
          ✖
        </button>
      </div>
      <form className={styles.popup_from_container} onSubmit={submitData}>
        <div className={styles.form_entry}>
          <label className={styles.entry_label}>{t('date')}</label>
          <div className={styles.time_container}>
            <div className={styles.time_date_container}>
              <ClockIcon className={styles.time_indicator_icon} />
              <input
                type='date'
                id='date'
                name='date'
                defaultValue={initDate}
                className={styles.entry_input}
                required
                lang="en-GB"
              />
            </div>
          </div>
        </div>
        <div className={styles.form_entry}>
          <div className={styles.radio_container}>
            <div className={styles.radio_input_container}>
              <input
                checked={isWithdraw}
                onChange={() => setIsWithdraw(true)}
                className={styles.entry_input}
                type='radio'
                id='withdraw'
                name='withdraw'
              />
              <label className={styles.entry_label} htmlFor='withdraw'>
                {t('withdraw')}
              </label>
            </div>
            <div className={styles.radio_input_container}>
              <input
                checked={!isWithdraw}
                onChange={() => setIsWithdraw(false)}
                className={styles.entry_input}
                type='radio'
                id='Input'
                name='Input'
              />
              <label className={styles.entry_label} htmlFor='Input'>
                {t('add')}
              </label>
            </div>
          </div>
          <div className={styles.form_entry}>
            <label className={styles.entry_label} htmlFor='amount'>
              {t('amount')}
            </label>
            <input defaultValue={exp?.amount} className={styles.entry_input} required type='number' step='0.01' id='amount' name='amount' />
          </div>
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='description'>
            {t('description')}
          </label>
          <textarea defaultValue={exp?.description || ''} className={styles.entry_input} type='text' id='description' name='description' />
        </div>
        <div className={styles.form_entry}>
          <button className={styles.submit_button} type='submit'>
            {data ? t('save') : t('add')}
          </button>
        </div>
      </form>
    </div>
  )
}
export default index
